var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ModalCampaignDelete',_vm._g(_vm._b({},'ModalCampaignDelete',{ campaignId: _vm.campaignId, deleting: _vm.deleting },false),{ submit: _vm.handleCampaignDelete }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }